import styled from 'styled-components';
import { Palette } from 'config';

const background = {
  red: Palette.Red._700,
  yellow: Palette.Amber._500,
  green: Palette.Teal._600,
  integration: Palette.Red._700,
};

// type: red, orange, green
export const CardWrap = ({ numCols = 1, type, style, children }) => {
  return (
    <Wrap type={type} style={{ gridColumn: `span ${numCols}`, ...style }}>
      {children}
    </Wrap>
  );
};

const Wrap = styled.div`
  background-color: ${({ type }) => background[type] || Palette.White._000};
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(30, 50, 70, 0.1), 0 1px 2px 0 rgba(30, 50, 70, 0.06);
  padding: 24px;
  padding-right: 10px;
  max-height: 468px;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 14px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-track {
    margin: 10px;
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border: 4px solid #fff;
    border-radius: 8px;
  }
`;
